import * as React from "react";
import {CSSProperties, ReactElement} from "react";
import {StoreControl, StoreControlProps, StoreControlState} from "../base/StoreControl";

import {ValidatorBase} from "../../utilities/validator/ValidatorBase";

import {PropertyValidator} from "../../utilities/validator/PropertyValidator";
import {StoreBase} from "shared/core/Store/StoreBase";


export class RNTextInput<S extends StoreBase> extends StoreControl<RNTextInputProps<S>, RNTextInputState> {
    static defaultProps: Partial<RNTextInputProps<any>> = {
        tooltip:null,
        type:'text',
        maxLength:undefined
    };

    constructor(props: RNTextInputProps<S>) {
        super(props);
        this.state={
            IsValid:true,
            ErrorMessage:''
        }
    }

    public render() {
        return (
            <div className={'rncontrol'} style={this.props.style}>
                <div>
                    {   this.props.Label!=''&&
                        <label style={{width: '100%', display: 'block'}}>{this.props.Label}
                            {
                                this.props.hint&&
                                    <span style={{display:'block',fontSize:12,color:'#5f5f5f',fontStyle:'italic'}}>{this.props.hint}</span>
                            }
                            {this.GetTooltip(this.props.tooltip)}
                        </label>
                    }
                    <input onClick={e=>this.props.onClick&&this.props.onClick(e)} style={this.props.inputStyle} onBlur={()=>this.props.OnBlur&&this.props.OnBlur()} maxLength={this.props.maxLength} placeholder={this.props.placeholder} type={this.props.type} disabled={this.props.disabled}  className={'rncontrol'} value={this.props.type=='numeric'?this.GetNumericValue():this.GetStringValue()} onChange={(e)=>{this.SetValue(e.target.value)}}/>
                    {this.GetValidationSection()}
                </div>
            </div>
        )
    }

    GetValidators(): ValidatorBase[] {
        return [
            new PropertyValidator(this.props,"Required",()=>{return this.GetStringValue()!=''},"Required field")
        ];
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface RNTextInputProps<S extends StoreBase> extends StoreControlProps<S>{
    style?:CSSProperties;
    inputStyle?:CSSProperties;
    Label:string;
    onChange?:(value:string)=>void;
    disabled?:boolean;
    type?:string;
    placeholder?:string;
    hint:string;
    tooltip:ReactElement;
    maxLength:number;
    OnBlur:()=>void;
    onClick:(e:React.MouseEvent)=>void;
}

interface RNTextInputState extends StoreControlState{

}

//#endregion "My Region"